import React from 'react';

export default function StudentHomepageSidebar() {
  return <div className='self-center justify-self-center px-x4 py-x3'>Sidebar Here</div>;
}
